<template>
  <InvoiceRecognition />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
